export default __webpack_public_path__ + "assets/images/favicon/android-chrome-192x192.png";